import {Routes} from "@angular/router";
import {WorkflowEndcustomerOneTrialCreateComponent} from "./workflow-endcustomer-one-trial-create.component";
import {
    WorkflowEndcustomerOneTrialPrepareComponent
} from "./workflow-endcustomer-one-trial-prepare/workflow-endcustomer-one-trial-prepare.component";

export const workflowEndcustomerOneTrialCreateRouting: Routes = [
    { path: 'one-trial', component: WorkflowEndcustomerOneTrialCreateComponent, children: [
            { path: 'nfr', component: WorkflowEndcustomerOneTrialCreateComponent },
            { path: 'trial-phonenumber', component: WorkflowEndcustomerOneTrialCreateComponent },
            { path: 'instance', component: WorkflowEndcustomerOneTrialCreateComponent },
            { path: 'phonenumber', component: WorkflowEndcustomerOneTrialCreateComponent },
    ]},
    // URL from email: loads sale order and shows cloud-thankyou without entering the trial creation workflow
    { path: 'trial/thank-you/:so', component: WorkflowEndcustomerOneTrialPrepareComponent },
    { path: 'trial', redirectTo: 'one-trial' }
]